// extracted by mini-css-extract-plugin
module.exports = {"cardSolutionSkeleton":"CardSolutionSkeleton_cardSolutionSkeleton__3M4dA","cardSolutionSkeleton_flexRow":"CardSolutionSkeleton_cardSolutionSkeleton_flexRow__3ZtGe"};